<modal-form-container
  title="Tags in this message"
  className="md:w-[600px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="sl">
      @if (selectedTags.length > 0) {
        <p class="sl__lead">
          Everyone in {{ selectedTags.length === 1 ? "this tag" : "these tags" }} gets the message. People in more than one get it
          once.
        </p>
        <ul class="sl__list">
          @for (item of selectedTags; track $index) {
            <li class="sl__row">
              <span class="sl__text">
                <span class="sl__name">{{ item.name || "Unnamed tag" }}</span>
                @if (item.description) {
                  <span class="sl__meta">{{ item.description }}</span>
                }
              </span>
              <button
                type="button"
                class="bk-icon-btn"
                [attr.aria-label]="'Remove ' + (item.name || 'tag')"
                matTooltip="Remove from message"
                (click)="handleRemoveTag(item)"
              >
                <span class="bk-sym" aria-hidden="true">close</span>
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="sl__empty">No tags chosen. Choose Tags in the Recipients section to add everyone with a tag.</p>
      }

      <div class="sl__foot">
        <button type="button" class="bk-btn bk-btn--primary" (click)="closeModal()">Done</button>
      </div>
    </div>
  }
</modal-form-container>
